import { EdhProtocolCombination } from "../../services/data-list/get-edh-protocol-combination-list/GetEdhProtocolCombinationListResponse";
import { ErrorMessage } from "../../util";
import { Option } from "../../util/option";

export type ComponentAdditionPageState = {
  searchResult: ComponentAddition;
  formEditData: ComponentAdditionFormEditData;
  formValidation: FormValidation;
  spreadsheetSelectedRowIndex: number | undefined;
  edhProtocolCombination: EdhProtocolCombination[];
  dataList: {
    cpntOwnType: Option[];
    cpntAlctnType: Option[];
    clodSrvc: Option[];
    clodSrvcRgn: Option[];
    edhProtcolList: Option[];
    startMethod: Option[];
    inboundNotificator: Option[];
    outboundNotificator: Option[];
    dipByRgnList: Option[];
    rootComponent: Option[];
    dynamicEdhProtocolList: Option[];
    dynamicStartMethod: Option[];
  };
  isEdited: boolean;
  displayColumn: Option[];
  fieldPath: {
    rootCpntId: string;
    rootCpntName: string;
    dipByRgn: string;
    ownTypeCd: string;
    systemName: string;
    systemId: string;
    subSystemId: string;
    notSystemUsg: string;
    alctnTypeCd: string;
    clodSrvcTypeCd: string;
    rgnTypeCd: string;
    acntName: string;
    cpntId: string;
    cpntName: string;
    cpntNameWtngChng: string;
    cpntDesc: string;
    gpgEncryptnFlg: string;
    useAssmdRoleFlg: string;
    useEdhCnvtrFlg: string;
    ediUsgFlg: string;
    edhPrtclList: string;
    ifStrtMthdList: string;
    edhNtfctnTypeList: string;
    hubFlg: string;
    updateDateTimeMCpnt: string;
  };
};

export type SpreadsheetMessage = {
  messageId: string;
  message: string;
  column: string;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type RootCpntIchrSpreadsheetRow = RootCpntIchr & SpreadsheetMessage;

export type SpreadsheetState = {
  rootCpntIchr: RootCpntIchrSpreadsheetRow[];
};

export type ComponentAddition = {
  godFlg: string;
  dipByRgn: string;
  rootCpntId: string;
  rootCpntName: string;
  ownTypeCd: string;
  systemName: string;
  systemId: string;
  subSystemId: string;
  alctnTypeCd: string;
  clodSrvcTypeCd: string;
  rgnTypeCd: string;
  acntName: string;
  notSystemUsg: string;
  rootCpntIchr: RootCpntIchr[];
  cpntId: string;
  cpntDesc: string;
  cpntName: string;
  gpgEncryptnFlg: string;
  useAssmdRoleFlg: string;
  ediUsgFlg: string;
  useEdhCnvtrFlg: string;
  hubFlg: string;
  edhPrtclList: EdhPrtcl[];
  ifStrtMthdList: IfStrtMthd[];
  edhNtfctnTypeList: EdhNtfctnType[];
};

export type ComponentAdditionFormEditData = {
  edhPrtclList: string[];
  ifStrtMthdList: string[];
  inboundNotificatorList: string[];
  outboundNotificatorList: string[];
};

export type FormValidation = {
  rootCpntId: boolean;
  rootCpntName: boolean;
  dipByRgn: boolean;
  ownTypeCd: boolean;
  systemName: boolean;
  systemId: boolean;
  subSystemId: boolean;
  notSystemUsg: boolean;
  alctnTypeCd: boolean;
  clodSrvcTypeCd: boolean;
  rgnTypeCd: boolean;
  acntName: boolean;
  cpntId: boolean;
  cpntName: boolean;
  cpntDesc: boolean;
  gpgEncryptnFlg: boolean;
  useAssmdRoleFlg: boolean;
  useEdhCnvtrFlg: boolean;
  hubFlg: boolean;
  edhPrtclList: boolean;
  ifStrtMthdList: boolean;
  inboundNotificatorList: boolean;
  outboundNotificatorList: boolean;
  ediUsgFlg: boolean;
};

export type RootCpntIchr = {
  isChanged: string;
  ichrId: string;
  ichrName: string;
  pstnName: string;
  cmpnyName: string;
  telNum: string;
  mlAdrs: string;
  updateDateTimeMRootCpntIchr: string;
};

export type RootCpntIchrKeys = keyof Omit<
  RootCpntIchr,
  "isChanged" | "updateDateTimeMRootCpntIchr"
>;

export type EdhPrtcl = {
  inOutTypeCd: string;
  edhPrtclTypeCd: string;
};
export type IfStrtMthd = {
  ifStrtMthdTypeCd: string;
};
export type EdhNtfctnType = {
  inOutTypeCd: string;
  edhNtfctnTypeCd: string;
};

export type EdhPrtclAttributeList = {
  cpntEdhPrtclMngDelFlg: string;
  cpntEdhPrtclMngEdhPrtclId: string;
  updateDateTimecpntEdhPrtclMngEdh: string;
  edhPrtclDisplayName: string;
  godFlg: string;
  inProgressCmpProjectId: string;
  inProgressCmpProjectName: string;
  waitingCmpProjectName: string;
  inProgressCmpProjectReqType: string;
  designStatusName: string;
  designStatus: string;
  updateDateTimeDesignStatus: string;
  stgDeployStatusName: string;
  prdDeployStatusName: string;
  edhPrtclAttribute: EdhPrtclAttribute[];
};

export type EdhPrtclAttribute = {
  error: string;
  edhPrtclAttributenum: string;
  key: string;
  stgDesignValue: string;
  updateDateTimeStgDesignValue: string;
  stgCurrentValue: string;
  prdDesignValue: string;
  updateDateTimePrdDesignValue: string;
  prdCurrentValue: string;
};

export type PageNewState =
  | ComponentAdditionPageState
  | ((prevState: ComponentAdditionPageState) => ComponentAdditionPageState);
